type cookieKey = 'jwt-token';

export function getCookie(key: cookieKey) {
  var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
}

export function setCookie(key: cookieKey, value: string, days = 365) {
  const date = new Date();
  // Set expiration date for the cookie
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "; expires=" + date.toUTCString();

  // Set the cookie with the provided key, value, and expiration
  document.cookie = `${key}=${value}${expires}; path=/`;
}

export function deleteCookie(key: cookieKey) {
  const removeWWW = (url: string) => {
    return url.replace(/^www(?=\.)/, '');
  }
  const hostname = removeWWW(document.location.hostname);

  // Set the cookie expiration to a past date, effectively deleting it
  document.cookie = `${key}=; Path=/; Domain=${hostname}; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Secure; SameSite=None;`;
}
